import React from 'react';
import { ContentArea } from '@styles/common';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { useParams } from 'react-router-dom';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { SeasonsTable } from '@screens/season/seasons.styles';

const columns = [
  { field: 'seasonId', headerName: 'Season Id', width: 200, flex: 0.5 },
  { field: 'startDate', headerName: 'Start Date', width: 200, flex: 0.5 },
  { field: 'taskId', headerName: 'Task Id', width: 200, flex: 0.5 },
  { field: 'task', headerName: 'Task', width: 200, flex: 0.5 },
  { field: 'taskParam', headerName: 'Task Param', width: 200, flex: 0.5 },
  { field: 'coins', headerName: 'coins', width: 200, flex: 0.5 },
  { field: 'stampName', headerName: 'Stamp Name', width: 200, flex: 0.5 },
];

interface SeasonInfo {
  seasonId: number;
}

let index = 0;
function createData(seasonInfo: SeasonInfo) {
  index += 1;
  return { id: index, ...seasonInfo };
}
interface SeasonParams {
  seasonId: string;
}

const SeasonMissions = () => {
  const { authorizedServices } = useAuth();
  const { seasonId } = useParams<SeasonParams>();

  async function runSearch(requestSeasonId: string, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<SeasonInfo[]>(`/admin/seasons/${requestSeasonId}`, { params: { page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(seasonId, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];

  return (
    <ContentArea>
      <SeasonsTable>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </SeasonsTable>
    </ContentArea>
  );
};

export default SeasonMissions;
